import type { UIStringsOverride } from "../i18n-ui.ts";

/** Arabic (ar) UI strings. */
export const ar: UIStringsOverride = {
  actions: {
    addToCursor: "إضافة إلى Cursor",
    addToVscode: "إضافة إلى VS Code",
    askAI: "اسأل الذكاء الاصطناعي عن هذه الصفحة",
    connectMcp: "الاتصال بـ MCP",
    copied: "تم النسخ!",
    copyClaudeCode: "نسخ أمر Claude Code",
    copyCode: "نسخ الكود",
    copyCodex: "نسخ أمر Codex",
    copyMarkdown: "نسخ بصيغة Markdown",
    copyServerUrl: "نسخ عنوان URL للخادم",
    edit: "التعديل على GitHub",
    export: "تصدير",
    exportEpub: "التصدير إلى EPUB",
    exportPdf: "التصدير إلى PDF",
    generating: "جارٍ الإنشاء…",
    openIn: "فتح في {name}",
    openInChat: "فتح في المحادثة",
    scrollToTop: "العودة إلى الأعلى",
  },
  ask: {
    ai: "الذكاء الاصطناعي",
    clear: "مسح المحادثة",
    close: "إغلاق",
    copy: "نسخ المحادثة",
    empty: "اطرح سؤالاً حول الوثائق.",
    error: "عذراً، حدث خطأ ما.",
    label: "اطرح سؤالاً",
    placeholder: "اطرح سؤالاً…",
    send: "إرسال",
    tip: "نصيحة: يمكنك فتح المحادثة وإغلاقها باستخدام",
    title: "اسأل الذكاء الاصطناعي",
    you: "أنت",
  },
  banner: { dismiss: "إغلاق الإعلان" },
  changelog: {
    description: "تحديثات المنتج وملاحظات الإصدارات.",
    showReleases: "عرض إصدارات {version}",
    title: "سجل التغييرات",
  },
  content: { diagramError: "تعذّر عرض هذا المخطط." },
  feedback: {
    no: "لا",
    question: "هل كانت هذه الصفحة مفيدة؟",
    thanks: "شكراً على ملاحظاتك!",
    yes: "نعم",
  },
  languageSwitcher: { label: "اللغة", untranslated: "غير مترجم" },
  nav: {
    back: "رجوع",
    breadcrumb: "مسار التنقل",
    closeNavigation: "إغلاق التنقل",
    deprecated: "مهمل",
    featured: "مميز",
    githubRepository: "مستودع GitHub",
    navigation: "التنقل",
    primary: "رئيسي",
    sections: "الأقسام",
    toggleNavigation: "تبديل التنقل",
    toggleTheme: "تبديل سمة الألوان",
  },
  notFound: {
    description: "لم نتمكن من العثور على الصفحة التي تبحث عنها.",
    home: "العودة إلى الصفحة الرئيسية",
    title: "الصفحة غير موجودة",
  },
  page: {
    lastUpdated: "آخر تحديث في",
    next: "التالي",
    pagination: "ترقيم الصفحات",
    previous: "السابق",
    skipToContent: "الانتقال إلى المحتوى",
  },
  search: {
    all: "الكل",
    allLanguages: "جميع اللغات",
    askAi: "اسأل الذكاء الاصطناعي",
    askAiHint: "احصل على إجابة فورية من الذكاء الاصطناعي",
    button: "بحث",
    devOnly: "البحث متاح في إصدار الإنتاج.",
    error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    label: "البحث في الوثائق",
    navigate: "تنقل",
    noResults: "لم يتم العثور على نتائج.",
    open: "فتح",
    placeholder: "البحث في الوثائق…",
    popular: "شائع",
    preview: "معاينة",
    results: "النتائج",
  },
  toc: { title: "في هذه الصفحة" },
};
